import {
    Button,
    IconButton,
    List,
    ListItem,
    ListItemSecondaryAction,
    ListItemText,
    Switch,
    TextField,
    Tooltip
  } from '@mui/material'
  import DeleteIcon from '@mui/icons-material/Delete'
  import AddIcon from '@mui/icons-material/Add'
  
  const EditorList = ({ items, onEditMode, addItem, updateItem, deleteItem }) => {
    const handleNameChange = (index, event) => {
      const updatedItem = { ...items[index], name: event.target.value }
      updateItem(index, updatedItem)
    }
  
    const handleToggleStatus = (index) => {
      const item = items[index]
      const updatedItem = { ...item, archived_at: item.archived_at ? null : new Date().toISOString() }
      updateItem(index, updatedItem)
    }
  
    return (
      <>
        <List>
          {items.map((item, index) => (
            <ListItem key={item.id || index}>
              {onEditMode ? (
                <TextField
                  value={item.name}
                  onChange={(e) => handleNameChange(index, e)}
                  placeholder="Enter name"
                />
              ) : (
                <ListItemText primary={item.name} />
              )}
              {onEditMode && (
                <ListItemSecondaryAction>
                  <Tooltip title={"Suspend"} arrow>
                    <Switch
                      checked={!item.archived_at}
                      onChange={() => handleToggleStatus(index)}
                      color="primary"
                    />
                  </Tooltip>
                  <IconButton
                    aria-label={`Delete ${item.name}`}
                    edge="end"
                    onClick={() => deleteItem(index)}
                  >
                    <DeleteIcon />
                  </IconButton>
                </ListItemSecondaryAction>
              )}
            </ListItem>
          ))}
        </List>
        {onEditMode && (
          <Button startIcon={<AddIcon />} onClick={addItem}>
            Add New
          </Button>
        )}
      </>
    )
  }
  
  export default EditorList
